// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'tenant-jurisdiction-detail.page.title': 'Tenant Jurisdiction Details',
    'tenant-jurisdiction-detail.page.search_results': 'Search Results',
    'tenant-jurisdiction-detail.page.create.title': 'Create New Tenant Jurisdiction Detail',
    'tenant-jurisdiction-detail.page.search.title': 'Find Tenant Jurisdiction Details',
    'tenant-jurisdiction-detail.page.edit.title': 'Edit Tenant Jurisdiction Detail',
    'tenant-jurisdiction-detail.page.view.title': 'View Tenant Jurisdiction Detail',
    'tenant-jurisdiction-detail.page.all': 'All',

    'tenant-jurisdiction-detail.button.cancel': 'Cancel',
    'tenant-jurisdiction-detail.button.select': 'Select',
    'tenant-jurisdiction-detail.button.find': 'Find Tenant Jurisdiction Details',
    'tenant-jurisdiction-detail.button.search': 'Apply',
    'tenant-jurisdiction-detail.button.create': 'Save Tenant Jurisdiction Detail',
    'tenant-jurisdiction-detail.button.new': 'New Tenant Jurisdiction Detail',
    'tenant-jurisdiction-detail.button.save': 'Save Changes',
    'tenant-jurisdiction-detail.button.delete': 'Permanently Delete',
    'tenant-jurisdiction-detail.button.edit': 'Edit',
    'tenant-jurisdiction-detail.button.restore': 'Restore',
    'tenant-jurisdiction-detail.button.reset': 'Reset',

    'tenant-jurisdiction-detail.placeholder.search': 'Search tenant jurisdiction details',

    'tenant-jurisdiction-detail.link.create_first_tenant_jurisdiction_detail': 'Click here to create your first tenant jurisdiction detail',
    'tenant-jurisdiction-detail.link.tenant_jurisdiction_details': ' Return to Tenant Jurisdiction Details',
    'tenant-jurisdiction-detail.link.retry': 'Click here to retry',

    'tenant-jurisdiction-detail.checkbox.all': 'Check All',
    'tenant-jurisdiction-detail.checkbox.actions_label': 'with selected',

    'tenant-jurisdiction-detail.label.jurisdiction_name': 'Jurisdiction',

    'tenant-jurisdiction-detail.label.label': 'Label',

    'tenant-jurisdiction-detail.label.value': 'Value',

    'tenant-jurisdiction-detail.label.value_type': 'Value Type',

    'tenant-jurisdiction-detail.label.application_code': 'Application Code',

    'tenant-jurisdiction-detail.label.application_sub_code': 'Application Sub Code',

    'tenant-jurisdiction-detail.label.from__created_at': 'From created at',
    'tenant-jurisdiction-detail.label.to__created_at': 'To created at',
    'tenant-jurisdiction-detail.label.created_at': 'Created At',

    'tenant-jurisdiction-detail.label.from__updated_at': 'From updated at',
    'tenant-jurisdiction-detail.label.to__updated_at': 'To updated at',
    'tenant-jurisdiction-detail.label.updated_at': 'Updated At',

    'tenant-jurisdiction-detail.label.from__deleted_at': 'From deleted at',
    'tenant-jurisdiction-detail.label.to__deleted_at': 'To deleted at',
    'tenant-jurisdiction-detail.label.deleted_at': 'Deleted At',

    'tenant-jurisdiction-detail.label.status': 'Status',

    'tenant-jurisdiction-detail.sort.field_label': 'Field',
    'tenant-jurisdiction-detail.sort.direction_label': 'Direction',
    'tenant-jurisdiction-detail.sort.direction_ascending': 'Ascending',
    'tenant-jurisdiction-detail.sort.direction_descending': 'Descending',

    'tenant-jurisdiction-detail.modal.title.tenant_jurisdiction_detail_delete_permanently': 'Delete Tenant Jurisdiction Detail',
    'tenant-jurisdiction-detail.modal.title.tenant_jurisdiction_detail_restore': 'Restore Tenant Jurisdiction Detail',

    'tenant-jurisdiction-detail.modal.message.tenant_jurisdiction_detail_delete_permanently':
        'Are you sure that you want to permanently delete this tenant jurisdiction detail? This action cannot be undone. | Are you sure that you want to permanently delete these tenant jurisdiction details? This action cannot be undone.',
    'tenant-jurisdiction-detail.modal.message.tenant_jurisdiction_detail_restore': 'Are you sure that you want to restore this tenant jurisdiction detail? | Are you sure that you want to restore these tenant jurisdiction details?',

    'tenant-jurisdiction-detail.success.message.tenant_jurisdiction_detail_created': 'Your tenant jurisdiction detail has been created',
    'tenant-jurisdiction-detail.success.message.tenant_jurisdiction_detail_updated': 'Your tenant jurisdiction detail has been updated',
    'tenant-jurisdiction-detail.success.message.tenant_jurisdiction_detail_restored': 'Your tenant jurisdiction detail has been restored | All selected tenant jurisdiction details were restored',
    'tenant-jurisdiction-detail.success.message.tenant_jurisdiction_detail_deleted': 'Your tenant jurisdiction detail has been permanently deleted | All selected tenant jurisdiction details were permanently deleted',

    'tenant-jurisdiction-detail.error.message.tenant_jurisdiction_detail_deleted': 'This tenant jurisdiction detail was already permanently deleted | These tenant jurisdiction details were already permanently deleted',
    'tenant-jurisdiction-detail.error.message.tenant_jurisdiction_detail_restored': 'This tenant jurisdiction detail was already restored | These tenant jurisdiction details were already restored',
    'tenant-jurisdiction-detail.error.message.error_loading_page': 'Sorry, there was an error loading tenant jurisdiction detail.| Sorry, there was an error loading tenant jurisdiction details.',
};
